import { render } from "./ProfileEditFormPanel.vue?vue&type=template&id=fa8b856e&scoped=true"
import script from "./ProfileEditFormPanel.vue?vue&type=script&lang=js"
export * from "./ProfileEditFormPanel.vue?vue&type=script&lang=js"

import "./ProfileEditFormPanel.vue?vue&type=style&index=0&id=fa8b856e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa8b856e"]])

export default __exports__